import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { dropRight } from 'lodash-es';
import { filter } from 'rxjs/operators';

@Injectable(
  { providedIn: 'root' }
)
export class NavigationService {

  private history: string[] = [];
  /**
   *
   */
  constructor(private router: Router, private location: Location) {

  }

  startSaveHistory() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    )
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects);
      });
  }

  getHistory() {
    return this.history;
  }

  goBack() {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    }
  }

  /**
   * Goes back to the most recent item in the history matching the URI.
   * Removes all history items which occured after the last history item of the URI.
   * In other words: go back to X and forget everything that happened after X.
   *
   * @param uri URI to go back to in the history
   */
  async goBackTo(uri: string) {
    // Last time the user was at the location we going back to
    const pointInHistory = this.history.lastIndexOf(uri);

    // Not found, default to back
    if (pointInHistory < 0) {
      console.warn(`${uri} no found in history, falling back to .goBack()`);
      return this.goBack();
    }

    // Get the number of items to drop from the end.
    // This prevents inifnite loop situations where the back button
    // may go between two pages.
    const itemsToDrop = (history.length + 1) - pointInHistory;
    this.dropNFromHIstory(itemsToDrop);
    return this.router.navigateByUrl(uri);
  }

  /**
   * Removes number of items at the end of the history
   * array.
   *
   * @param n Number to drop from end
   */
  dropNFromHIstory(n: number): string[] {
    this.history = dropRight(this.history, n);
    return this.getHistory();
  }

  getPreviousUrl() {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2];
    }

    return '';
  }
}
